<template>
    <div>
        <slot name="add"></slot>

        <v-row class="no-frame mt-0 mb-3" v-if="showTitle">
            <v-col class="no-frame pr-2">
                <v-switch
                    v-model   = "contract.active"
                    label     = "Vertrag aktiv"
                    :readonly = "readonly"
                    :ripple   = "false"
                    hide-details
                    class="ma-0"
                />
            </v-col>
            <v-col class="no-frame pb-0 mb-0">
                <div style="padding-top: 5px; text-align: right; font-size: 15px;" class="w-100">
                    <span class="primary--text">{{ $t('contract.hcid') }}</span>
                    <span class="pl-2">{{ contract.id === 0 ? '---' : contract.id }}</span>
                </div>
            </v-col>
        </v-row>

        <v-row class="no-frame mt-0 mb-0">
            <v-col class="no-frame">
                <f-read-only-field
                    class="w-100"
                    :label = "$t('contract.company')"
                    :value = "contract.company.name"
                    color="pt-0-5 pl-1 ro-background"
                />
            </v-col>
        </v-row>

        <v-row class="no-frame" v-if="showCustomer">
            <c-customer-select
                v-if    = "contract"
                v-model = "contract.customer"
                label   = "Kunde"
                :lim-customer = "true"
                :rules  = "[ requiredRule]"
            />
        </v-row>
        <slot name="post" />
    </div>
</template>

<script>

import Core            from "@/modules/core/service/Core";
import FReadOnlyField  from "@/modules/core/components/utils/FReadOnlyField";
import CCustomerSelect from "@/modules/msd/company/customer/components/controlls/CCustomerSelect";

export default {
    name: "CContractHeader",
    components: {
        CCustomerSelect,
        FReadOnlyField,
    },

    props: {
        contract: {
            required: true,
            type    : Object
        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        showCustomer: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        showTitle: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    computed: {
        requiredRule() {
            return Core.rule.required;
        },
    },

    methods: {
        dateAsString (value) {
            return Core.format.date.display(value);
        }
    }
}
</script>

<style scoped>

</style>